<app-phx-card
    [spaceBetween]="true"
    [fullWidth]="true"
    [borderLeftColor]="'#0d6efd'"
    [showAssetLoader]="showAssetLoader()"
    [showInnerDataLoader]="showInnerDataLoader()"
>
    <ng-template #assetArea>
        <div class="employee-asset-img">
            <app-widget-asset-preview
                #assetPreview
                [asset]="assetModel.value()?.asset"
                (selectFiles)="onFilesSelected($event)"
                [editable]="photoEditable"
                [dataTestId]="'employee-header-card'"
            />
        </div>
    </ng-template>
    <ng-template #innerData>
        <div class="flex flex-col justify-between relative">
            @if (employee()?.id) {
                <div class="absolute top-0 right-0">
                    <app-base-model-info-widget [detailModel]="employee()" tooltipPosition="left" />
                </div>
            }
            <div class="mb-0 text-2xl font-semibold">
                @if (employee() && displayName() && !loadingSig()) {
                    <span data-testid="employee-name-in-header-card">{{ displayName() }}</span>
                } @else if (employee()?.id && !displayName()) {
                    <span data-testid="employee-missing-name">{{ 'employee.no-name' | translate }}</span>
                } @else {
                    <span data-testid="new-employee">{{ 'employee.employee-edit' | translate }}</span>
                }
            </div>
            <div>
                @if (showIdentifier && employee()?.id && displayIdentifier && !loadingSig()) {
                    <span
                        [pTooltip]="'employee.identifier' | translate"
                        [attr.data-testid]="'employee-identifier-in-header-card'"
                    >{{ displayIdentifier }}</span>
                } @else if (!employee()?.id) {
                    <span data-testid="employee-number-in-header-card">{{
                        'employee.save-for-employee-number' | translate
                    }}</span>
                }
            </div>
        </div>
    </ng-template>
    @if (showContactActions) {
        <ng-template #buttons>
            <div class="bg-white dark:bg-gray-800">
                <p-button
                    [disabled]="employee()?.phone?.length < 1 || !phoneIsValid"
                    (click)="callTo(employee()?.phone)"
                    icon="fa-solid fa-phone-alt"
                    styleClass="dark:bg-gray-800"
                ></p-button>
                <p-button
                    [disabled]="!employee()?.mobilePhone || !mobilePhoneIsValid"
                    class="ms-1"
                    (click)="callTo(employee()?.mobilePhone)"
                    icon="fa fa-mobile-alt"
                    styleClass="dark:bg-gray-800"
                ></p-button>
                <p-button
                    [disabled]="!employee()?.email || !emailIsValid"
                    class="ms-1"
                    (click)="mailTo(employee()?.email)"
                    icon="fa fa-envelope"
                    styleClass="dark:bg-gray-800"
                ></p-button>
            </div>
        </ng-template>
    }
</app-phx-card>
